/**
 * structureFromDdlEditContext — the one accessor every compact DDL body arm
 * uses to get its parsed `DdlStructure`. Mirrors how the Table Designer
 * derives `buffer.structure` (`table-designer/hooks/useDesignerBuffer.ts`):
 * ask the bound resolver service to extract the structure for the parked
 * statement, and treat a throw as "this head isn't structurally extractable"
 * (the extractor throws by design for anything outside its whitelist).
 *
 * Pure + defensive: never throws, so a malformed or unsupported statement
 * degrades to a read-only body instead of blanking the popover.
 *
 * Redesign: .superpowers/sdd/2026-07-28-compact-visual-ddl-editor/ (T3).
 */
import type { DdlStructure } from '../../../sql-resolver/types/ddlEdit';
import type { VqeDdlEditContext } from '../edit/editContext';

export function structureFromDdlEditContext(
  editContext: VqeDdlEditContext | null,
): DdlStructure | null {
  if (!editContext) return null;
  try {
    return editContext.service.extractDdlStructure(
      editContext.documentId,
      editContext.statementId,
    );
  } catch {
    return null;
  }
}
